// connectVertexArrays.ts
import { HalfedgeDS } from '../core/HalfedgeDS';
import { Vertex } from '../core/Vertex';

/**
 * Connects consecutive vertices with edges if not already connected.
 * Uses struct.addEdge(v1, v2) and reuses existing edges when present.
 */
export function connectVertexArrays(struct: HalfedgeDS, vertices: Vertex[]): void {
  if (!vertices || vertices.length < 2) return;

  for (let i = 0; i < vertices.length - 1; i++) {
    const a = vertices[i];
    const b = vertices[i + 1];

    // Skip if already connected by any halfedge A->B or B->A
    if (a.isConnectedToVertex(b)) continue;

    // Create a single pair of halfedges between a and b
    // (no parallels needed for “path” wiring)
    struct.addEdge(a, b, /*allowParallels=*/ false);
  }
}
